import { axiosRequest } from '../../axiosRequest';

const adapterPaymentInformationResponse = ({ data, success }) => {
	if (success === false) return { error: true, data };
    
	const paymentInformation = data.data;

	return paymentInformation;
};

export const getPaymentInformation = async (memberId) => {
    let options = {
			method: 'get',
			url: `stripe/member/${memberId}/payment-information`,
			tokenFailedReload: true,
		};

    const response = await axiosRequest(options);
    const totalMembers = adapterPaymentInformationResponse(response);

    return totalMembers;
};
